module.exports = __webpack_public_path__ + "static/media/videos-3@2x.3005dd39.jpg";